import { createAuthAxios } from './auth';

const contactsService = {
  /**
   * Fetches all WhatsApp contacts from QuePasa
   * @param {number} accountId - Account ID
   * @param {number} inboxId - Inbox ID
   * @returns {Promise<Array<{phone: string, name: string, picture: string}>>} WhatsApp contacts
   * @example
   * const contacts = await quepasa.service.contacts.fetch(1, 803);
   */
  async fetch(accountId, inboxId) {
    const http = createAuthAxios();
    const response = await http.get(
      `/api/v1/accounts/${accountId}/quepasa/${inboxId}/contacts/fetch`
    );
    return response.data;
  },

  async preview(accountId, inboxId) {
    const http = createAuthAxios();
    const response = await http.get(
      `/api/v1/accounts/${accountId}/quepasa/${inboxId}/contacts/preview`
    );
    return response.data;
  },

  async import(accountId, inboxId, contacts) {
    const http = createAuthAxios();
    const response = await http.post(
      `/api/v1/accounts/${accountId}/quepasa/${inboxId}/contacts/import`,
      { contacts }
    );
    return response.data;
  }
};

// Add help properties to each method
contactsService.fetch.help = 'fetch(accountId, inboxId) - Fetches all WhatsApp contacts from QuePasa. Returns: Array<{phone, name, picture}>';
contactsService.preview.help = 'preview(accountId, inboxId) - Previews contacts before import. Shows what would be imported.';
contactsService.import.help = 'import(accountId, inboxId, contacts) - Imports WhatsApp contacts to Chatwoot. Pass contacts array.';

export default contactsService;
